var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.033 10.682C10.9713 12.3305 12.3365 13.6957 13.985 14.634L14.869 13.396C15.0112 13.1969 15.2213 13.0569 15.4598 13.0023C15.6983 12.9478 15.9484 12.9825 16.163 13.1C17.5773 13.8729 19.1392 14.3378 20.746 14.464C20.9968 14.4839 21.2308 14.5975 21.4015 14.7823C21.5722 14.9671 21.667 15.2094 21.667 15.461V19.923C21.667 20.1706 21.5752 20.4094 21.4094 20.5932C21.2435 20.777 21.0153 20.8927 20.769 20.918C20.239 20.973 19.705 21 19.167 21C10.607 21 3.66699 14.06 3.66699 5.5C3.66699 4.962 3.69399 4.428 3.74899 3.898C3.77425 3.6517 3.88998 3.42352 4.07378 3.25763C4.25759 3.09175 4.4964 2.99995 4.74399 3H9.20599C9.45755 2.99997 9.69989 3.09475 9.88467 3.26545C10.0695 3.43615 10.1831 3.67022 10.203 3.921C10.3292 5.52779 10.7941 7.08968 11.567 8.504C11.6845 8.71856 11.7192 8.96874 11.6647 9.2072C11.6101 9.44565 11.4701 9.65584 11.271 9.798L10.033 10.682V10.682ZM7.51099 10.025L9.41099 8.668C8.87178 7.50409 8.50234 6.26884 8.31399 5H5.67699C5.67099 5.166 5.66799 5.333 5.66799 5.5C5.66699 12.956 11.711 19 19.167 19C19.334 19 19.501 18.997 19.667 18.99V16.353C18.3982 16.1646 17.1629 15.7952 15.999 15.256L14.642 17.156C14.0957 16.9437 13.565 16.6931 13.054 16.406L12.996 16.373C11.0346 15.2567 9.41027 13.6324 8.29399 11.671L8.26099 11.613C7.9739 11.102 7.72328 10.5713 7.51099 10.025V10.025Z",
    fill: "#BDBDBD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/Icon_Phone.251173ed48bc170875011ab2bbde3b92.svg";
export { ForwardRef as ReactComponent };